import type { KyInstance } from 'ky';

import { ensureError, formatString, isNotDefined } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { Mailing } from './types/mailing.type';

/**
 * Updates an existing mailing by sending a PUT request to the mailing update endpoint.
 *
 * @param instance - The KyInstance used to make HTTP requests.
 * @param mailing - The Mailing object containing updated mailing data.
 * @returns A promise that resolves to an OperationResult indicating the outcome of the update operation.
 * @throws Will throw an error if the HTTP request fails.
 */
export const updateMailing = async (instance: KyInstance, mailing: Mailing) => {
  try {
    if (isNotDefined(mailing.id)) {
      throw new Error('Mailing id is required for update.');
    }

    return await instance.put<OperationResult>(formatString(Uri.mailing.update, mailing.id.toString()), {
      json: mailing,
    });
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
